var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.animation,"afterEnter":"onOpen(2)"},on:{"beforeLeave":function($event){_vm.onClose(1)},"afterLeave":function($event){_vm.onClose(2)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticClass:"fv-dialog",on:{"click":function($event){$event.stopPropagation();return true}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/framevuerk-builder/node_modules/pug-html-loader/lib!./node_modules/framevuerk-builder/node_modules/vue-loader/lib??vue-loader-options!./src/components/fvDialog.vue?vue&type=template&id=cd434884&lang=pug&
// module id = 145
// module chunks = 0 1